import React from 'react'
import './brandedBBAds.scss'
import HeroSection, { CtaBrand } from './../components/heroSection';
import { SectionWrapper } from '../../../theme/layouts/MainLayout';
import { adsBrand } from '../../../common/utils/constant';
import { Col, Row } from 'react-bootstrap';
import AppImage from '../../../common/features/image';

function BrandedBBAds() {
  const scrollToTop = (e) => {
    e.preventDefault();
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };  

  return (
    <div className='page-1'>
      <HeroSection data={adsBrand.branded} />
      <SectionWrapper style={{ background: 'linear-gradient(273.12deg, #0046BE 0%, #7026BF 121.29%)' }}>
        <section className='section2'>
          <Row>
            <Col md={6} sm={12}>
              <h2>Deep customer relationships</h2>
              <p>Best Buy is connected with over 200 million customers across their entire CE journey—all while they learn, try, buy and love the products that make their lives better.</p>
              <p>And with Best Buy Ads, you’re right there, too.</p>
            </Col>
            <Col md={6} sm={12}>
            <div className='sec2-right-container'>
              <div className='quote-title'>
                “We are changing the way consumer electronics brands achieve their advertising goals<span>—all thanks to our deep customer relationships.”</span>
              </div>
              <div className='author-name'>
                Jen Jensen<br />
                VP, Best Buy Ads Partner & Category Marketing
              </div>
              </div>
            </Col>
          </Row>

        </section>
      </SectionWrapper>

      <SectionWrapper>
        <section className='section3'>
          <div>
            <h2>Full-funnel solutions</h2>
            <p>Reach and engage your customers with our data-driven solutions across the entire sales funnel—like awareness ads on CTV, social media moments that expand the conversation and product experiences on BestBuy.com and the Best Buy app that help you seal the deal.</p>
            <p className='second-para'>However your brand wants to be a part of the customer journey, we have an advertising solution for you.</p>
          </div>

          <div className='div2'>
            <h2>Closed-loop reporting</h2>
            <p>We capture billions of data points to create greater return on interaction—in-store, online and wherever your customers may be. With an approximately 90% revenue identification rate, we can prove the path from ad exposure to purchase for your most relevant CE audiences. </p>
            <p>And for advertisers who demand more customization, our self-service opportunities give partners extra levers to pull to influence their campaigns.</p>
          </div>

          <div className="image">
            <AppImage src="/images/adsLandingPages/ClosedLoopReporting.png" alt="" />
            <p>Work with our Reporting & Insights team to track the success of your campaigns. </p>
          </div>

          <div className='div3'>
            <h2>Relationships are the answer</h2>
            <p>Ready to start driving results with our data-driven retail media solutions? <a href='javascript:void(0)' className='energy-purple' onClick={scrollToTop}>Fill out the form</a> above to connect with a retail media expert today and learn more about reaching CE shoppers. </p>
            <CtaBrand iconFile={'/images/common/icons/cheveron-up-purple.png'} />
          </div>
        </section>

      </SectionWrapper>

    </div>
  )
}

export default BrandedBBAds